import React, { useState } from "react";
import Select, { components } from "react-select";
import CreatableSelect from "react-select/creatable";
import "../../styles/DropDownComponent.css";
import "../../styles/MultiSelectDropdown.css";

const multiStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

// Option row with a checkbox in front of the label. The checkbox is display
// only — react-select owns selection, and the row's own click handler toggles
// it — so it is not separately focusable.
const CheckboxOption = (props) => (
  <components.Option {...props}>
    <input
      type="checkbox"
      className="msd-option-checkbox"
      checked={props.isSelected}
      readOnly
      tabIndex={-1}
    />
    <span>{props.label}</span>
  </components.Option>
);

// Multi-select searchable dropdown. `value`/`onChange` both deal in arrays of
// {label,value} objects (not plain ids) — react-select needs the full object
// to render selected chips, and callers that only need ids map .value
// themselves at the point of use.
//
// In creatable mode, typing a brand-new option calls the async
// `onCreateOption(name)` (expected to resolve to a real {label,value} pair —
// e.g. by hitting a find-or-create API) before it's added to the selection,
// so the caller never ends up with an unresolved raw name in its value.
const MultiSelectDropdown = ({
  options = [],
  value = [],
  onChange,
  placeholder = "Select…",
  isCreatable = false,
  onCreateOption,
  // Shows a checkbox against every option and keeps the menu open while
  // picking, for fields where several values are the normal case.
  showCheckboxes = false,
  isDisabled = false,
}) => {
  const [creating, setCreating] = useState(false);

  const handleCreateOption = async (inputValue) => {
    if (!onCreateOption) return;
    setCreating(true);
    try {
      const created = await onCreateOption(inputValue);
      if (created) onChange([...value, created]);
    } finally {
      setCreating(false);
    }
  };

  const SelectComponent = isCreatable ? CreatableSelect : Select;
  const creatableProps = isCreatable
    ? { onCreateOption: handleCreateOption, isLoading: creating, formatCreateLabel: (input) => `Create "${input}"` }
    : {};

  return (
    <div className="msd-wrapper">
      <SelectComponent
        options={options}
        value={value}
        onChange={(selected) => onChange(selected || [])}
        placeholder={placeholder}
        isMulti
        isClearable
        isSearchable
        isDisabled={isDisabled}
        classNamePrefix="dropdown"
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={multiStyles}
        {...(showCheckboxes
          ? {
              components: { Option: CheckboxOption },
              hideSelectedOptions: false,   // a ticked box must stay visible
              closeMenuOnSelect: false,     // keep picking without reopening
            }
          : {})}
        {...creatableProps}
      />
    </div>
  );
};

export default MultiSelectDropdown;
